import type { RatingState } from "@esgt/event-store"
import type { Question } from "@esgt/types"

/**
 * Resolves a question's `defaultValues` config into concrete form values.
 *
 * String values are used as-is. `{ fromDatapoint: "name" }` values are
 * resolved from the current rating state. If any `fromDatapoint` reference
 * can't be resolved, that entry is omitted.
 *
 * Returns `undefined` when there are no defaults to apply.
 */
export function deriveDefaultValues(
  question: Question,
  ratingState: RatingState | undefined,
): Record<string, string> | undefined {
  if (!question.defaultValues || !ratingState) return undefined

  const result: Record<string, string> = {}
  let hasValues = false

  for (const [field, value] of Object.entries(question.defaultValues)) {
    if (typeof value === "string") {
      result[field] = value
      hasValues = true
    } else {
      const resolved = ratingState.datapoints[value.fromDatapoint]
      result[field] = resolved !== undefined ? resolved.toString() : ""
      hasValues = true
    }
  }

  return hasValues ? result : undefined
}
